/* eslint-disable no-param-reassign */
import { createActionTypeReducer } from 'util/reducers'
import { updateCount as updateFaviconCount } from 'util/favicon'
import { withPush, without } from 'util/arrays'
import {
  ROOMS_REALTIME_LOAD_UNREAD,
  ROOMS_REALTIME_SYNC_UNREAD,
  ROOM_OPTIMISTIC_UPDATED,
  ROOMS_UPDATED,
} from 'ducks/chat/actionTypes/rooms'
import { getRoomId, getIsRead } from 'ducks/chat/utils/rooms'
import { getMatrixClient } from 'ducks/chat/utils/client'
import { SEARCH_SYNC } from 'ducks/searches/actionTypes'
import { getAddedConversationIds } from 'ducks/searches/utils/query'

const initialState = {
  unreadRoomIds: [],
  pendingUnreadRoomIds: [],
}

export default createActionTypeReducer(
  {
    [ROOMS_REALTIME_SYNC_UNREAD]: (draftState, action) => {
      const {
        payload: { roomId, isRead, isInChat },
      } = action
      const stateKey = isInChat ? 'pendingUnreadRoomIds' : 'unreadRoomIds'
      const mutateAction = isRead ? without : withPush
      mutateAction(draftState[stateKey], roomId)
      updateFaviconCount(draftState.unreadRoomIds.length)
    },
    [ROOMS_REALTIME_LOAD_UNREAD]: (draftState, action) => {
      const { payload: unreads } = action
      const ids = unreads
        .filter(unread => !unread.inChat || !unread.room || !unread.room.isRead)
        .map(unread => unread.id)
      draftState.unreadRoomIds = ids
      draftState.pendingUnreadRoomIds = []
      updateFaviconCount(ids.length)
    },
    [SEARCH_SYNC]: (draftState, action) => {
      const {
        payload: { searches },
      } = action
      if (draftState.pendingUnreadRoomIds.length === 0) return
      const addedConversationIds = getAddedConversationIds(searches)
      if (addedConversationIds.length === 0) return
      const client = getMatrixClient()
      if (!client) return
      draftState.pendingUnreadRoomIds.forEach(matrixRoomId => {
        const room = client.getRoom(matrixRoomId)
        const roomId = getRoomId(room)
        if (addedConversationIds.includes(roomId)) {
          withPush(draftState.unreadRoomIds, matrixRoomId)
          without(draftState.pendingUnreadRoomIds, matrixRoomId)
        }
      })
      updateFaviconCount(draftState.unreadRoomIds.length)
    },
    [ROOM_OPTIMISTIC_UPDATED]: (draftState, action) => {
      const {
        payload: {
          room: { isRead, matrixRoomId },
          oldRoom: { isRead: wasRead },
        },
      } = action
      if (isRead === wasRead) return

      const mutateAction = isRead ? without : withPush
      mutateAction(draftState.unreadRoomIds, matrixRoomId)
      without(draftState.pendingUnreadRoomIds, matrixRoomId)
      updateFaviconCount(draftState.unreadRoomIds.length)
    },
    [ROOMS_UPDATED]: (draftState, action) => {
      const {
        payload: {
          roomUpdates,
          currentSearch: { conversationIds },
        },
      } = action
      if (!roomUpdates) return
      const rooms = roomUpdates.map(roomUpdate => roomUpdate.room)
      rooms.forEach(room => {
        const roomId = getRoomId(room)
        if (!conversationIds.includes(roomId)) return
        const matrixRoomId = room.roomId
        const isRead = getIsRead(room)
        const mutateAction = isRead ? without : withPush
        mutateAction(draftState.unreadRoomIds, matrixRoomId)
        without(draftState.pendingUnreadRoomIds, matrixRoomId)
      })
      updateFaviconCount(draftState.unreadRoomIds.length)
    },
  },
  initialState
)
